import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'd365-connector-panel',
    templateUrl: './d365.connector.panel.html'
})
export class D365ConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@Dynamics365',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.D365Info',
            ControlType: D365ConnectorPanel,
            Default: null
        };
    }
}
